export default "__VITE_ASSET__C$xvs$Wz__"